/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import { Button, Card, Col, Container, Form, Row, Table } from 'react-bootstrap'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import BreadCrumb from '../../components/Label/Breadcrumb'
import api from '../../config/AxiosInstance'
import toast, { Toaster } from 'react-hot-toast'
import Loading from '../../components/atoms/Loading'
import { Menu } from 'lucide-react'

const tableHeaderStyle = {
  fontSize: '14px',
  fontWeight: '600',
  color: '#333333',
  letterSpacing: '0.5px',
  backgroundColor: '#f8f9fa',
  borderBottom: '2px solid #e9ecef'
}

const cardFilterStyle = {
  border: 'none',
  boxShadow: '0 2px 12px rgba(0,0,0,0.04)',
  borderRadius: '12px',
  padding: '1.5rem',
  marginBottom: '1.5rem',
  backgroundColor: '#fff'
}

const labelStyle = {
  fontSize: '0.75rem',
  fontWeight: '700',
  color: '#999',
  textTransform: 'uppercase',
  marginBottom: '0.25rem',
  letterSpacing: '0.5px'
}

const valueStyle = {
  fontSize: '0.9rem',
  fontWeight: '500',
  color: '#212529',
  minHeight: '24px'
}

export default function ManualStockOpnameItemDetail() {
  const { state } = useLocation()
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)
  const { opnameId, id } = useParams()
  const [data, setData] = useState({
    values: null,
    metadata: {
      per_page: 10,
      current_page: 1,
      total_row: 0,
      total_page: 0
    }
  })
  const [collapsible, setCollapsible] = useState({})
  const handleBack = () => {
    navigate(`/stock-opname/manual-stock-opname/detail/${opnameId}`, {
      replace: true,
      state: state
    })
  }
  const fetchData = async () => {
    try {
      setLoading(true)
      const res = await api.get(`/stock-opname/manual/${opnameId}/${id}`)
      const { data: dataResponse, metadata: metadataResponse } = res.data
      const valueCollapsibles = dataResponse?.racks?.flatMap(
        (rack) => rack.rack_name
      )
      setData({
        values: dataResponse,
        metadata: metadataResponse
      })
      setCollapsible(
        valueCollapsibles?.reduce((acc, code) => {
          acc[code] = true
          return acc
        }, {})
      )
    } catch (error) {
      const errMsg =
        error?.response?.data?.errors?.message ||
        error?.message ||
        'An error occurred'
      toast.error(errMsg, {
        position: 'top-right',
        style: {
          fontSize: '14px',
          fontWeight: '600'
        }
      })
      handleBack()
    } finally {
      setLoading(false)
    }
  }
  const columnItems = [
    { key: 'rack_name', label: 'Rack Name' },
    { key: 'checker', label: 'Checker' },
    { key: 'pic', label: 'PIC' },
    {
      key: 'action',
      label: 'Action',
      className: 'd-flex justify-content-end',
      component: (value) => (
        <div key={value?.id} className="d-flex justify-content-end">
          <Button
            variant="transparent"
            className="btn-secondary"
            size="md"
            onClick={() =>
              setCollapsible((prev) => ({
                ...prev,
                [value.rack_name]: !prev[value.rack_name]
              }))
            }
          >
            <Menu size={14} />
          </Button>
        </div>
      )
    }
  ]
  const columnSlots = [
    { key: 'slot', label: 'Slot' },
    { key: 'total_pack', label: 'Pack (sys)' },
    {
      key: 'total_pack_checker',
      label: 'Checker Check',
      component: (value) => (
        <div key={value.slot}>
          {value.total_pack_checker && (
            <span
              className="fw-bold"
              style={{
                color: `${
                  value.total_pack_checker > value.total_pack
                    ? '#2F80ED'
                    : '#219653'
                }`
              }}
            >
              {value.total_pack_checker}
            </span>
          )}
        </div>
      )
    },
    {
      key: 'checker_info',
      label: 'Checker Info',
      component: (value) => value?.checker_info ?? ''
    },
    {
      key: 'total_pack_pic',
      label: 'PIC Check',
      component: (value) => (
        <div key={value.slot}>
          {value.total_pic_checker && (
            <span
              className="fw-bold"
              style={{
                color: `${
                  value.total_pic_checker > value.total_pack
                    ? '#2F80ED'
                    : '#219653'
                }`
              }}
            >
              {value.total_pic_checker}
            </span>
          )}
        </div>
      )
    },
    {
      key: 'pic_info',
      label: 'PIC Info',
      component: (value) => value?.pic_info ?? ''
    }
  ]
  useEffect(() => {
    fetchData()
  }, [opnameId, id])

  if (loading) {
    return <Loading />
  }

  const renderInfoItem = (label, value, col = 3) => (
    <Form.Group className={`mb-3 col-12 col-md-${col}`}>
      <Form.Label style={labelStyle}>{label}</Form.Label>
      <div className="px-0" style={valueStyle}>
        {value || '-'}
      </div>
    </Form.Group>
  )

  return (
    <>
      <Toaster />
      <Container fluid className="px-4 mb-5">
        <Row className="mb-4">
          <Col md={12}>
            <BreadCrumb
              label={data?.values?.code || ''}
              link="/stock-opname/manual-stock-opname"
              back="MANUAL STOCK OPNAME"
              labelSub="DETAIL"
              labelSubLink={`/stock-opname/manual-stock-opname/detail/${opnameId}`}
              status={data?.values?.status}
              type="BadgeStatusPrList"
              stateValue={state}
            />
          </Col>
        </Row>

        <Card style={cardFilterStyle}>
          <Row>
            {renderInfoItem('ITEM NAME', data?.values?.item_name, 9)}
            {renderInfoItem('BATCH', data?.values?.batch, 3)}
          </Row>
        </Card>

        <Card style={cardFilterStyle}>
          <Row>
            <Col md={12}>
              <Table
                hover
                responsive
                className="shadow-sm bg-white"
                style={{
                  fontSize: '13px',
                  borderRadius: '12px',
                  overflow: 'hidden',
                  marginBottom: 0
                }}
              >
                <thead style={{ backgroundColor: '#f8f9fa' }}>
                  <tr>
                    {columnItems.map((column) => (
                      <th
                        className={`align-middle p-2 ${column.className}`}
                        key={column.key}
                        style={tableHeaderStyle}
                      >
                        <span>{column.label}</span>
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {data?.length === 0 && (
                    <tr>
                      <td
                        colSpan={columnItems.length}
                        className="p-2 text-center"
                      >
                        No data
                      </td>
                    </tr>
                  )}
                  {data?.values?.racks?.length > 0 &&
                    data?.values?.racks?.map((item, index) => {
                      return (
                        <React.Fragment key={`${item.id}-${index}`}>
                          <tr>
                            {columnItems.map((column) => (
                              <td
                                key={column.key}
                                className={`align-middle p-2 ${column.className}`}
                              >
                                {column.component
                                  ? column.component(item)
                                  : item[column.key]}
                              </td>
                            ))}
                          </tr>
                          {collapsible[item.rack_name] && (
                            <tr>
                              <td
                                colSpan={columnItems.length}
                                className="p-2 bg-light"
                              >
                                <div className="p-2">
                                  <Table className="bg-white" bordered>
                                    <thead className="table-secondary">
                                      <tr>
                                        {columnSlots.map((column) => (
                                          <th
                                            className={`align-middle p-2 ${column.className}`}
                                            key={column.key}
                                          >
                                            <span>{column.label}</span>
                                          </th>
                                        ))}
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {item?.slots?.length === 0 && (
                                        <tr>
                                          <td
                                            colSpan={columnSlots.length}
                                            className="p-2 text-center"
                                          >
                                            No data
                                          </td>
                                        </tr>
                                      )}
                                      {item?.slots?.length > 0 &&
                                        item?.slots?.map((item, index) => (
                                          <tr key={`${item.id}-${index}`}>
                                            {columnSlots.map((column) => (
                                              <td
                                                key={column.key}
                                                className={`align-middle p-2 ${column.className}`}
                                              >
                                                {column.component
                                                  ? column.component(item)
                                                  : item[column.key]}
                                              </td>
                                            ))}
                                          </tr>
                                        ))}
                                    </tbody>
                                  </Table>
                                </div>
                              </td>
                            </tr>
                          )}
                        </React.Fragment>
                      )
                    })}
                </tbody>
              </Table>
            </Col>
          </Row>
        </Card>
      </Container>
    </>
  )
}
